import React from 'react'
import { graphql, useFragment } from 'react-relay'

import { YStack, XStack } from 'tamagui'
import {
  GuildPrimaryPhoto,
  UserPrimaryPhoto,
  Icon,
  Text,
  Paragraph,
  Link,
} from '@newComponents'

import { EventScreenOwner_event$key } from './__generated__/EventScreenOwner_event.graphql'

export const EventScreenOwner = ({
  event,
}: {
  event: EventScreenOwner_event$key
}) => {
  const data = useFragment(
    graphql`
      fragment EventScreenOwner_event on Event {
        owner {
          __typename

          ... on Guild {
            name
            slugId

            primaryPhoto {
              rowId
            }

            ...GuildPrimaryPhotoNew_guild
          }

          ... on User {
            firstName
            lastName

            slugId

            ...UserPrimaryPhotoNew_user
          }
        }
      }
    `,
    event
  )

  if (!data.owner) {
    return null
  }

  switch (data.owner.__typename) {
    case 'Guild': {
      return (
        <Link href={`/${data.owner.slugId}`} underlineHover={false}>
          <XStack gap='$4' alignItems='center'>
            {data.owner.primaryPhoto ? (
              <GuildPrimaryPhoto
                guild={data.owner}
                size='$10'
                borderWidth={0}
                // @ts-ignore boxShadow is web-only
                boxShadow='$boxShadowTight'
              />
            ) : (
              <YStack
                width='$10'
                height='$10'
                alignItems='center'
                justifyContent='center'
                backgroundColor='$background'
                borderRadius='$2'
                // @ts-ignore boxShadow is web-only
                boxShadow='$boxShadowLight'
              >
                <Icon name='people' size='$7' color='$color' />
              </YStack>
            )}

            <YStack flex={1}>
              <Paragraph size='$4' color='$colorMuted' fontWeight='$3'>
                Hosted by
              </Paragraph>

              <Paragraph size='$5' fontWeight='$5' flex={1}>
                {data.owner.name}
              </Paragraph>
            </YStack>
          </XStack>
        </Link>
      )
    }
    case 'User': {
      return (
        <Link href={`/${data.owner.slugId}`} underlineHover={false}>
          <XStack gap='$4' alignItems='center'>
            <UserPrimaryPhoto
              user={data.owner}
              size='$10'
              // @ts-ignore boxShadow is web-only
              boxShadow='$boxShadowTight'
            />

            <YStack flex={1}>
              <Paragraph size='$4' color='$colorMuted' fontWeight='$3'>
                Hosted by
              </Paragraph>

              <Paragraph size='$5' fontWeight='$5' flex={1}>
                {data.owner.firstName} {data.owner.lastName}
              </Paragraph>
            </YStack>
          </XStack>
        </Link>
      )
    }
  }

  return null
}
